import {
  Briefcase16Regular,
  Briefcase24Regular,
  Building16Regular,
  Building24Regular,
  DataTrending16Regular,
  DataTrending24Regular,
  Folder16Regular,
  Folder24Regular,
  Globe16Regular,
  Globe24Regular,
  Home16Regular,
  Home24Regular,
  People16Regular,
  People24Regular,
  Person16Regular,
  Person24Regular,
  Rocket16Regular,
  Rocket24Regular,
  Sparkle16Regular,
  Sparkle24Regular,
} from '@/components/Icon'

export const workspaceIconPackA = {
  briefcase: { 16: Briefcase16Regular, 24: Briefcase24Regular },
  building: { 16: Building16Regular, 24: Building24Regular },
  folder: { 16: Folder16Regular, 24: Folder24Regular },
  sparkle: { 16: Sparkle16Regular, 24: Sparkle24Regular },
  rocket: { 16: Rocket16Regular, 24: Rocket24Regular },
  chart: { 16: DataTrending16Regular, 24: DataTrending24Regular },
  home: { 16: Home16Regular, 24: Home24Regular },
  person: { 16: Person16Regular, 24: Person24Regular },
  people: { 16: People16Regular, 24: People24Regular },
  globe: { 16: Globe16Regular, 24: Globe24Regular },
}
